





























import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { PropType } from '@nuxtjs/composition-api'
import { RelatedSearch, RelatedSearchEntry } from '~/models/classified/related'

export default Vue.extend({
  props: {
    search: {
      required: true,
      type: Object as PropType<RelatedSearch>
    }
  },
  computed: {
    ...mapState(CLASSIFIED_SEARCH_NS, {
      isMapSearch: state => state.flags.isMapSearch
    })
  },
  methods: {
    ...mapActions(CLASSIFIED_SEARCH_NS, {
      loadSeoUrlSearch: 'loadSeoUrlSearch'
    }),
    handleClickLink(url: string) {
      if (this.isMapSearch) {
        this.loadSeoUrlSearch({ seoUrl: url })
      }
    },
    getSearchTitle(search: RelatedSearchEntry) {
      return search.name || search.title?.shortTitle || ''
    }
  }
})
